import React, { useEffect, useRef, useState } from "react";
import "./dashboard.css";
import Footer from "../../components/footer/Footer";
import Nav from "../../components/nav/Nav";
import CustomButton from "../../components/CustomButton";
import { ReactComponent as HeadephoneIcon } from "../../assets/Headphones Round.svg";
import { ReactComponent as SettingIcon } from "../../assets/Settings.svg";
import { ReactComponent as Map } from "../../assets/map-white.svg";
import { ReactComponent as EyeIcon } from "../../assets/fi-rr-eye.svg";
import { ReactComponent as MessageRedIcon } from "../../assets/messageRedIcon.svg";
import { ReactComponent as NewMessageWhiteIcon } from "../../assets/newMessageWhiteIcon.svg";
import { Modal, Table, Tooltip } from "@mantine/core";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import base_url from "../../api/bootapi";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../components/Reducers/userSlice";
import { IconContract } from "@tabler/icons-react";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as DocumentIcon } from "../../assets/Document.svg";
import { ReactComponent as DownloadIcon } from "../../assets/download.svg";
import Swal from "sweetalert2";
import { get, set } from "react-hook-form";
import { toast } from "react-toastify";
import ViewFileModal from "../../components/Modals/ViewFileModal";
import moment from "moment";
import { Button } from "reactstrap";
import { ReactComponent as Close } from "../../assets/modalCloseIcon.svg";

import AdditionalClaim from "./AdditionalClaim";
const DraftListPage = () => {
  const navigate = useNavigate();
  // const [data, setData] = useState([]);
  const { user } = useSelector((state) => state.user);


    const location = useLocation();
    const [data, setData] = useState(location.state?.compensationData || []);
    
    const contact = location.state?.contact || null;
    const dob = location.state?.date_of_birth || null;


  
  const [countArray, setCountArray] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [backdropopen, setbackdropopen] = useState(false);
  
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalTitle, setImageModalTitle] = useState("");
  const [imageModalFileUrl, setImageModalFileUrl] = useState("");
  const [userId, setUserId] = useState(null);  



   
  
 
  
  
  const closeImageModal = () => {
    setImageModalOpen(false);
  };


  
 

   

  
  
  
   
 
  
   
  
 
    useEffect(() => {
      if ( !dob && !contact) {
        navigate("/draft-claim-status");
      }
    }, [contact,dob]);


  //   useEffect(() => {
  //   if (!user ) {
  //     navigate("/login");
  //   }
  // }, [user]);

     

  // useEffect(() => {
  //   if (!user && !userIdFromState ) {
  //     navigate("/claimstatus");
  //   }
  // }, [userIdFromState]);


   const openImageViewModal = (title, fileUrl) => {
    setImageModalTitle(title);
    setImageModalFileUrl(fileUrl);
    setImageModalOpen(true);
  };
    const isImageFile = (url) => {
    // Example function to check if the URL ends with a common image file extension
    return /\.(jpeg|jpg|png|gif)$/i.test(url);
  };
  const handleViewFile = (elem) => {
      console.log("callinf")
      if (!elem) {
        return;
      }
      //console.log("Element", attachmenturl + elem);
      const fileUrl = base_url.api1 + elem;
      if (!isImageFile(fileUrl)) {
        window.open(fileUrl, "_blank");
      } else {
        openImageViewModal("View File", fileUrl);
      }
    };

 

  



  useEffect(() => {

  const getDraftList = async () => {
      
  
   
    setbackdropopen(true);

      axios
      .get(
        `${base_url.api1}/users/draft_compensation_request?contact_no=${contact}&date_of_birth=${dob}`
      )
      .then((response) => {
        console.log("31------>", response?.data);
          setbackdropopen(false);
          console.log(response?.data)
       setData(response?.data?.compensation_requests || []);
        // navigate("/edit-claim/" + response?.data?.Compensation?.id);
        setUserId("");
        
      })
      .catch((error) => {
        console.log("Error", error);
        setbackdropopen(false);
        Swal.fire({
          icon: "error",
          title: "No Record Found",
          html: `No record found for claim ID:<strong>${userId}</strong>`,
          confirmButtonText: "Ok",
        });
      });
    }
    
   
      getDraftList();
    

  },[currentPage]);

 
  const handleEditClick = (id) => {
    navigate(`/edit-claim/${id}`);
  };

   const truncateText = (file) => {
    if (!file) {
      return false;
    }

    const tempFile = file?.split("/").pop();

    const filename =
      tempFile.length > 12 ? tempFile.slice(0, 12) + "..." : tempFile;

    return filename;
  };

  
   
  
  
  


 
  const [openClaimDeleteModal, setOpenClaimDeleteModal] = useState(false);
  const [deleteDraftId, setDeleteDraftId] = useState(null);
  
  const handleDeleteModalOpen = (id) => {
      setDeleteDraftId(id);
      setOpenClaimDeleteModal(true);
    };
  
    const closeClaimDeleteModal = () => {
      setOpenClaimDeleteModal(false);
    };

 
  const deleteDraft = () => {
  
closeClaimDeleteModal()

    setbackdropopen(true);
    const id = deleteDraftId;
        axios

          .delete(`${base_url.api1}/users/draft_compensation_request?id=${id}`)
          .then((response) => {
    setbackdropopen(false);

            console.log("Delete Response", response?.data);
            toast.success("Draft deleted successfully");
            // Refresh the draft list after deletion
            setData((prevData) =>
              prevData.filter((draft) => draft.id !== id)
            );
          })
          
          .catch((error) => {
    setbackdropopen(false);
            
            console.log("Error", error);
            toast.error("Failed to delete draft");
          }
          );
      }
   
  
  const mobileRows = data?.map((claimData, index) => {
    

      const element = claimData?.request_data;

    




    

    return (
    <div className="mobile-row" key={claimData.id}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <span
            className="claim-id-text"
            style={{
              color: "#222222",
              fontSize: "18px",
              lineHeight: "20px",
              fontWeight: 600,
            }}
          >
            Contact No: <span className="claim-id">{element.contact_no}</span>
          </span>
         
        </div>

        {/* <span
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#E8EEF7",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/view-claim/${element.id}`)}
        >
          <EyeIcon />
        </span> */}
      </div>

      <hr style={{ color: "#CBDAF0" }} />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Submitted date</span>

          <span
            style={{ fontSize: "14px", lineHeight: "20px", color: "#222222" }}
          >
            {new Date(claimData.created_at).toLocaleDateString("en-US")}
          </span>
          </div>
          
            <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Name</span>

          <span
            style={{ fontSize: "14px", lineHeight: "20px", color: "#222222" }}
          >
            {element?.first_name} {element?.last_name}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Claim type</span>

          <span
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#222222",
              textTransform: "capitalize",
            }}
          >
            {/* {element?.type_of_claim
              ? element?.type_of_claim === "overbooking" ||
                element?.type_of_claim === "denied_boarding"
                ? "Denied Boarding"
                : element?.type_of_claim
              : "-"} */}
              Temporary Save
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Status</span>

          <span className="mobile-claim-label">
            {
              <span
                style={{
                  textTransform: "capitalize",
                  fontSize: "14px",
                  lineHeight: "20px",
                  borderRadius: "16px",
                  padding: "4px 16px",
                 background:"#f4f4f4",
                  color:
                    element.status === "In review"
                      ? "#FFC107" // yellow
                      : element.status === "Waiting for airline"
                      ? "#E5742D" // orange (unchanged)
                      : element.status === "Documents needed"
                      ? "#D04244" // red (unchanged)
                      : element.status === "paid"
                      ? "#2196F3" // blue
                      : element.status === "approved"
                      ? "#4CAF50" // green
                      : element.status === "appealed"
                      ? "#FF9800" // deep orange
                      : element.status === "rejected"
                      ? "#F44336" // red
                      : element.status === "incomplete"
                      ? "#717171ff" // grey
                      : element.status === "pending"
                      ? "#FF9800" // orange
                      : "rgba(0, 0, 0, 1)", // default
                }}
              >
                {claimData.status}
              </span>
            }
          </span>
        </div>
        {/* {element.status === "incomplete" && (
          <button
            className="dashboard-edit-button"
            onClick={() => handleEditClick(element.id)}
          >
            <IconContract size={18} color="#314064" /> Draft
          </button>
        )} */}
      </div>

        

      
      
     
        <button className="access-btn" style={{ width: "100%",background:"rgb(49, 64, 100)", height: "initial", marginTop: "20px", padding: "12px", fontSize: "14px" }} onClick={() => navigate(`/edit-claim/${claimData?.id}`)}>Edit Claim</button>
        <button className="access-btn" style={{ width: "100%", height: "initial", marginTop: "20px", padding: "12px", fontSize: "14px" }} onClick={() => handleDeleteModalOpen(claimData?.id)}>Delete</button>
        
        

       

        
       
        

    </div>
  )
  } 
  );

  const rows = data?.map((claimData, index) => {

      const element = claimData?.request_data;


    
    return(

    
      <div key={index} style={{background:"#fff",width:"100%"}} className="table-wrap">
         <div  className="table-row" style={{padding:"15px 20px",width:"100%",justifyContent:"space-between"}}>
        <span className='table-td table-contact' style={{width:"170px"}}>{element.contact_no}</span>
        {/* {element.status === "incomplete" ? (
        <Table.Td className="dashboard-edit-button-container">
          <button
            className="dashboard-edit-button"
            onClick={() => handleEditClick(element.id)}
          >
            <IconContract size={18} color="#314064" /> Draft
          </button>
        </Table.Td>
      ) : ( */}
        {/* <Table.Td>-</Table.Td> */}
        {/* )} */}
        {/* {element.status === "incomplete" && <Link to="/file-claim"><Table.Td>
        edit
      </Table.Td></Link>} */}
        <span className='table-td table-date' style={{width:"170px"}}>
          {new Date(claimData.created_at).toLocaleDateString("en-US")}
        </span>
         <span className='table-td table-name' style={{width:"170px"}}>
         {element?.first_name} {element?.last_name}
        </span>
        
        <span className='table-td table-claim' style={{width:"170px"}}>
          <span style={{ textTransform: "capitalize" }}>
            {/* {element?.type_of_claim
              ? element?.type_of_claim === "overbooking" ||
                element?.type_of_claim === "denied_boarding"
                ? "Denied Boarding"
                : element?.type_of_claim
              : "-"} */}
              Temporary Save
          </span>
        </span>
        <span className='table-td table-status' style={{width:"170px"}}>
          {
            <span
              style={{
                textTransform: "capitalize",
                borderRadius: "16px",
                padding: "4px 16px",
                backgroundColor: "#f4f4f4"
              }}
            >
              {claimData.status}
            </span>
          }
        </span>
     
        <span className='table-td table-buttons' style={{width:"170px",minWidth:"initial"}}>
       
          <button className="access-btn" style={{background:"rgb(49, 64, 100)"}} onClick={() => navigate(`/edit-claim/${claimData?.id}`)}>Edit Claim</button>
          <button className="access-btn"  onClick={() => handleDeleteModalOpen(claimData?.id)}>Delete</button>

           
       
       
        
        
        </span>

       
     
        </div>
      
      
        

      </div>
     
    )
  });

  return (
    <div>
      <Nav  />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropopen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>


        <Modal
              opened={openClaimDeleteModal}
              onClose={closeClaimDeleteModal}
              centered
              radius={"lg"}
              size={"md"}
              withCloseButton={false}
            >
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "30px",
                  padding: "30px",
                }}
              >
                {/* <CircleTickIcon /> */}
                <h5
                  style={{ color: "#314064", fontSize: "24px", textAlign: "center" }}
                >
                  Are you sure want to delete ?
                </h5>
      
                <div className="logout-btn-wrapper">
                  <CustomButton
                    style={{ width: "50%" }}
                    btnText={"Cancel"}
                    flex={1}
                    onClick={closeClaimDeleteModal}
                    type="secondary"
                  />
      
                  <CustomButton
                    style={{ width: "50%" }}
                    btnText={"Delete"}
                    flex={1}
                    onClick={deleteDraft}
                    type="danger"
                  />
                </div>
              </div>
            </Modal>

      <div className="dashboard-container draft-container" >
        <div className="welcome-wrapper">
          <Map className="welcome-map" />
          <div className="greet-wrapper">
            <h4 className="mid-header" style={{ color: "#FAFDFF" }}>
             
              Welcome{" "}
            
            </h4>
            <span className="sub-header" style={{ color: "#FAFDFF" }}>
              Here’s an overview of your claims
            </span>
          </div>
          <div className="action-wrapper">
            <span
              onClick={() => navigate("/contact-us")}
              className="contact-support sub-header"
              style={{ zIndex: 10 }}
            >
              <HeadephoneIcon /> Contact our support team
            </span>
            <span
              onClick={() => navigate("/account-settings")}
              className="setting-icon"
            >
              <SettingIcon />
            </span>
          </div>
        </div>

        <div className="mobile-wrapper my-claim-header-wrapper">
          <h4 className="dashboard-header">Drafts</h4>
          <CustomButton
            onClick={() => navigate("/start-your-claim")}
            btnText={"Start New Claim"}
          />
        </div>
        <div className="my-claim-wrapper desktop-wrapper">
          <div className=" my-claim-header-wrapper">
            <h4 className="dashboard-header">Drafts</h4>
            <CustomButton
              onClick={() => navigate("/start-your-claim")}
              btnText={"Start New Claim"}
            />
          </div>

          <div className="table-wrapper" style={{overflowX:"scroll"}}>
           
             
                <div className="table-row table-head"  style={{width:"100%",justifyContent:"space-between"}}>
                  <span className='table-td table-contact' style={{width:"170px"}}>Contact No</span>
                  {/* <span>Edit</span> */}
                  <span className='table-td table-date' style={{width:"170px"}}>Submitted date</span>
                  <span className='table-td table-name' style={{width:"170px"}}>Name</span>
                  <span className='table-td table-claim' style={{width:"170px"}}>Claim type</span>
                  <span className='table-td table-status' style={{width:"170px"}}>Status</span>
                  
                  <span className='table-td table-buttons' style={{width:"170px",minWidth:"initial"}}>Action</span>
                </div>
             
              {/* <Table.Tbody>{rows}</Table.Tbody> */}
             
                {data?.length === 0 ? (
                  <div style={{display:"flex",justifyContent:"center"}}>
                    <span  className="text-center py-4">
                      No Drafts
                    </span>
                  </div>
                ) : (
                  rows
                )}
             
           
          </div>
        </div>

        <div
          className="pagination-container"
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "8px",
              backgroundColor: "#314064",
              color: "#fff",
              border: "none",
              borderRadius: "20px",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
              opacity: currentPage === 1 ? 0.6 : 1,
            }}
          >
            <IconChevronLeft size={20} />
          </button>

          <span style={{ fontWeight: "500" }}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "8px",
              backgroundColor: "#314064",
              color: "#fff",
              border: "none",
              borderRadius: "20px",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              opacity: currentPage === totalPages ? 0.6 : 1,
            }}
          >
            <IconChevronRight size={20} />
          </button>
        </div>

        <div className="mobile-row-wrapper mobile-wrapper">
          {data.length === 0 ? (
            <div style={{ textAlign: "center", marginTop: "30px" }}>
              No Drafts
            </div>
          ) : (
            mobileRows
          )}
        </div>
      </div>

       <ViewFileModal
              isOpen={imageModalOpen}
              closeModal={closeImageModal}
              modalTitle={imageModalTitle}
              modalFileUrl={imageModalFileUrl}
            />
      <Footer />
    </div>
  );
};

export default DraftListPage;
